import { Container } from '@global-engineering-shared/gweb-material-ui';
import { useEffect, useMemo, useState } from 'react';

import LoadableComponent from 'components/LoadableComponent';
import TablePageHeader from 'components/TablePageHeader';
import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import DataManagementTable from 'features/DataManagement/components/DataManagementTable';
import FrameServiceButtons from 'features/DataManagement/components/FrameServiceButtons';
import { CurrentUploadedFile } from 'features/DataManagement/data/CurrentUploadedFile';
import { DataManagementLatest } from 'features/DataManagement/data/DataManagementLatest';
import { useFrameServiceStatus } from 'features/DataManagement/hooks/useFrameServiceStatus';
import useFetchData from 'hooks/useFetchData';
import { DATA_MANAGEMENT_DATA_API_URL } from 'utils/defaults';

type CurrentUploadedFileWithStatus = CurrentUploadedFile & {
  uploadInProgress: boolean;
};

const DataManagementPage = () => {
  const [data, setData] = useState<DataManagementLatest>();
  const { refreshToggle } = useRefresh();
  const { getData, isDataLoading } = useFetchData();
  const { uploadInProgress, isStatusLoading } = useFrameServiceStatus();

  useEffect(() => {
    getData<DataManagementLatest>(DATA_MANAGEMENT_DATA_API_URL, setData);
  }, [refreshToggle]);

  const tableData: CurrentUploadedFileWithStatus[] = useMemo(() => {
    return (data?.currentUploadedFiles ?? []).map((file) => ({
      ...file,
      uploadInProgress: data?.uploadInProgress ?? false,
    }));
  }, [data]);

  return (
    <main>
      <Container maxWidth="lg">
        <TablePageHeader title="Data Management" showSearchBar={false} showImport={false} />
        <LoadableComponent loading={isDataLoading || isStatusLoading}>
          <DataManagementTable data={tableData} />
          <FrameServiceButtons uploadInProgress={uploadInProgress} />
        </LoadableComponent>
      </Container>
    </main>
  );
};

export default DataManagementPage;
